import React from 'react';
import logo from './logo.svg';

export interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => (
  <img className={className} src={logo} width={180} height={21} alt={''} />
)

export { Logo };
